// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-20adda21] .el-form-item__content .el-date-editor:nth-of-type(2){margin-left:8px}", ""]);
// Exports
module.exports = exports;
